import { useCurrentProduct } from "@drift/oneplatfront-components";
import { useLayout } from "@onefront/react-sdk";
import { useEffect } from "react";

const TitleGate = () => {
    const { setTitle } = useLayout();
    const { product } = useCurrentProduct(true);

    useEffect(() => {
        if (product?.label) {
            setTitle(product.label);
        }
    }, [product]);

    return null;
};

export default TitleGate;
